<div
    class="orb-app-light-dark:justify-start vl-app-light:border-none var-app-light-dark:justify-start white_smoke flex items-center justify-between border-t border-solid border-opacity-10 px-4 pb-1 pt-4 dark:border-contrast-yellow"
    *ngIf="
        env.JOURNEY_PLANNER?.SHOW_PRICES &&
        (!env.JOURNEY_PLANNER?.HIDE_PRICE_BLOCK_IF_PRICE_UNAVAILABLE || (price && currency))
    ">
    <div
        class="orb-app-light-dark:pr-2 var-app-light-dark:pr-2 flex items-center gap-4"
        *ngIf="isEnabled"
        [class.hidden]="env.JOURNEY_PLANNER?.SHOW_FULL_WIDTH_BUTTON">
        <img
            class="h-auto w-6 text-grey-zambezy"
            [src]="
                (assetsPath$ | async) +
                (env.EXPLORE?.USE_CONTRAST_ICON && (isContrast$ | async)
                    ? '/img/journey-planner/icon-tickets-contrast.svg'
                    : '/img/journey-planner/icon-tickets.svg')
            "
            aria-hidden="true" />
        <p class="leading-5" *ngIf="!env.IS_NEW_AFC">{{ price }} {{ currency }}</p>
    </div>

    <!-- Normal button -->
    <button
        class="var-app-light:text-primary var-app-light-dark:font-semibold flex items-center gap-2 overflow-hidden text-secondary dark:text-contrast-yellow"
        *ngIf="!env.JOURNEY_PLANNER?.SHOW_FULL_WIDTH_BUTTON"
        (click)="env.JOURNEY_PLANNER?.SHOW_TICKET_PURCHASE_TIME_MODAL ? openTicketPurchaseModal() : buyTickets()">
        {{ 'BUY_TICKET_JP' | translate }}
        <ion-icon class="vl-app-light:hidden" name="arrow-forward-outline" aria-hidden="true"></ion-icon>
    </button>

    <!-- Full width button -->
    <button
        class="orb-app-light:bg-primary orb-app-light:text-black vl-app-light:bg-[#93c751] vl-app-light:text-black flex h-12 w-full items-center justify-center gap-2 rounded-lg bg-secondary text-base font-semibold text-white shadow-[0_1px_2px_0_rgba(0,0,0,0.3)] dark:bg-contrast-yellow dark:text-contrast-black"
        *ngIf="env.JOURNEY_PLANNER?.SHOW_FULL_WIDTH_BUTTON"
        (click)="env.JOURNEY_PLANNER?.SHOW_TICKET_PURCHASE_TIME_MODAL ? openTicketPurchaseModal() : buyTickets()">
        {{ 'BUY_TICKET_JP' | translate }}
    </button>
</div>
